<ion-tabs [slot]="plt.tabMenuOnTop ? 'top' : 'bottom'">

    <ion-tab-bar *ngIf="!plt.hideBottomMenu && !plt.isConnected"
                 slot="bottom">
        <div class="offline">
            {{ 'LEFT_MENU_APP_IS_OFFLINE' | translate}}
        </div>
    </ion-tab-bar>


    <ng-template #tabButtons>
        <ion-tab-button tab="messages"
                        [ngClass]="{'tab-selected': messagesActive.isActive}"
                        (click)="refreshMessages()">
            <svg-icon [applyClass]="true"
                      src="/assets/icons/ico-messages.svg"
                      class="fill-menu-contrast"></svg-icon>
            <ion-label>{{ 'LEFT_MENU_MESSAGES' | translate }}</ion-label>
            <ion-badge *ngIf="plt.unreadMessages + plt.unreadChatGroups + plt.unreadNotifications"
                       class="notification">
                {{ plt.unreadMessages + plt.unreadChatGroups + plt.unreadNotifications }}
            </ion-badge>
        </ion-tab-button>

        <a routerLink="/tabs/messages"
           routerLinkActive
           #messagesActive="routerLinkActive"
           style="display: none"></a>

        <ion-tab-button *ngIf="!event?.disable_appointments"
                        tab="appointments"
                        (click)="refreshAppointments()">
            <svg-icon [applyClass]="true"
                      src="/assets/icons/ico-appointments.svg"
                      class="fill-menu-contrast"></svg-icon>
            <ion-label>{{ 'LEFT_MENU_APPOINTMENTS' | translate }}</ion-label>
            <ion-badge *ngIf="plt.unreadAppointments"
                       class="notification">
                {{ plt.unreadAppointments }}
            </ion-badge>
        </ion-tab-button>

        <ion-tab-button tab="home/info/matching"
                        [ngClass]="{'tab-selected': manageKeywordsActive.isActive || matchingActive.isActive}">
            <svg-icon [applyClass]="true"
                      src="/assets/icons/ico-dashboard.svg"
                      class="fill-menu-contrast"></svg-icon>
            <ion-label *ngIf="event?.is_homepage_content_stream">{{ 'LEFT_MENU_STREAM' | translate }}</ion-label>
            <ion-label *ngIf="!event?.is_homepage_content_stream">{{ 'LEFT_MENU_DASHBOARD' | translate }}</ion-label>
        </ion-tab-button>

        <!-- <ion-tab-button *ngIf="matchingActive.isActive"
    *ngIf="manageKeywordsActive.isActive || (!manageKeywordsActive.isActive && !matchingActive.isActive)"
                    tab="home/info/manage-keywords"
                    [ngClass]="{'tab-selected': manageKeywordsActive.isActive || matchingActive.isActive}">
        <svg-icon [applyClass]="true"
                  src="/assets/icons/ico-dashboard.svg"
                  class="fill-menu-contrast"></svg-icon>
        <ion-label>{{ 'LEFT_MENU_DASHBOARD' | translate }}</ion-label>
    </ion-tab-button> -->

        <a routerLink="/tabs/home/info/matching"
           routerLinkActive
           #matchingActive="routerLinkActive"
           style="display: none"></a>
        <a routerLink="/tabs/home/info/manage-keywords"
           routerLinkActive
           #manageKeywordsActive="routerLinkActive"
           style="display: none"></a>
        <a routerLink="/tabs/home/marketplace/list"
           routerLinkActive
           #marketplaceActive="routerLinkActive"
           style="display: none"></a>

        <ion-tab-button *ngIf="event?.marketplaces.length > 0"
                        tab="home/marketplace/list"
                        [ngClass]="{'tab-selected': marketplaceActive.isActive }">
            <svg-icon [applyClass]="true"
                      src="/assets/icons/pricetags-outline.svg"
                      class="fill-menu-contrast custom">
            </svg-icon>
            <ion-label>
                <ng-container *ngIf="event.translate(userLang).tab_marketplace">
                    {{ event.translate(userLang).tab_marketplace }}
                </ng-container>
                <ng-container *ngIf="!event.translate(userLang).tab_marketplace">
                    {{ 'DASHBOARD_SUBMENU_MARKETPLACE' | translate }}
                </ng-container>
            </ion-label>
        </ion-tab-button>

        <ion-tab-button tab="home/attendees/list"
                        [ngClass]="{'tab-selected': attendeesActive.isActive}">
            <svg-icon [applyClass]="true"
                      src="/assets/icons/ico-attendee.svg"
                      class="fill-menu-contrast">
            </svg-icon>
            <ion-label *ngIf="!event?.is_community">{{ 'LEFT_MENU_ATTENDEES' | translate }}</ion-label>
            <ion-label *ngIf="event?.is_community">{{ 'LEFT_MENU_ATTENDEES_COMMUNITY' | translate }}</ion-label>
            <a routerLink="/tabs/home/attendees/list"
               routerLinkActive
               #attendeesActive="routerLinkActive"
               style="display: none"></a>
        </ion-tab-button>

        <ion-tab-button (click)="openMenu()"
                        class="side-menu">
                <ion-menu-button menu="end"></ion-menu-button>
            <ion-label>{{'LEFT_MENU_MENU' | translate}}</ion-label>
            <ion-badge *ngIf="plt.unreadOtherCount"
                       class="notification">
                {{ plt.unreadOtherCount }}
            </ion-badge>
        </ion-tab-button>
    </ng-template>

    <ion-tab-bar *ngIf="plt.tabMenuOnTop && plt.isConnected && plt.sizeLg"
                 slot="top">

        <ng-template [ngTemplateOutlet]="tabButtons">
        </ng-template>

    </ion-tab-bar>

    <ion-tab-bar *ngIf="!plt.hideBottomMenu && !plt.tabMenuOnTop && plt.isConnected && plt.sizeLg"
                 slot="bottom">

        <ng-template [ngTemplateOutlet]="tabButtons">
        </ng-template>

    </ion-tab-bar>

</ion-tabs>
